import { useLocation } from "react-router-dom";

import "../../Styles/App.css";
import "./Header.css";
import EdfLogo from "../../Ressources/Images/EdfLogo.svg";
import SiteNameLabel from "../../Components/SiteNameLabel/SiteNameLabel";
import ContactButton from "../../Components/ContactButton/ContactButton";

function PageHeader() {
  const location = useLocation();
  if (location.pathname === "/") {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img src={EdfLogo} className="App-logo" alt="logo" />
        <SiteNameLabel />
        <ContactButton/>
      </div>
    );
  }

  return (
    <header className="header">
      <a href="/" className="Header-logo">
        <img src={EdfLogo} alt="logo" />
      </a>
      <h1 className="Title">Site de Paluel</h1>
      <ContactButton/>
    </header>
  );
}

export default PageHeader;
